import React from 'react'

import GroupWrapper from '../../components/GroupWrapper'
import Flex from '../../../../../components/layouts/Flex'

import RecruitmentStageFunnelList from './RecruitmentStageFunnelList'
import AcceptedApplicantList from './AcceptedApplicantList'
import RecruitersAssignedRolesAndStage from './RecruitersAssignedRolesAndStage'
import TotalRolesPerRecruiter from './TotalRolesPerRecruiter'
import RecruitersCandidateCount from './RecruitersCandidateCount'
import LoginAndSignupsHistory from './LoginAndSignupsHistory'

const OverviewTables = () => {
    return (
        <GroupWrapper title="Tables - Overview">
            <Flex
                direction="column"
                width="100%"
                height="100%"
                padding="1rem"
                overflowY="off"
                bB="1px solid #AEB3C9"
            >
                <RecruitmentStageFunnelList />
            </Flex>
            <Flex
                direction="column"
                width="100%"
                height="100%"
                padding="1rem"
                overflowY="off"
                bB="1px solid #AEB3C9"
            >
                <AcceptedApplicantList />
            </Flex>
            <Flex
                direction="column"
                width="100%"
                height="100%"
                padding="1rem"
                overflowY="off"
                bB="1px solid #AEB3C9"
            >
                <RecruitersAssignedRolesAndStage />
            </Flex>
            <Flex
                direction="column"
                width="100%"
                height="100%"
                padding="1rem"
                overflowY="off"
                bB="1px solid #AEB3C9"
            >
                <TotalRolesPerRecruiter />
            </Flex>

            <Flex
                direction="column"
                width="100%"
                height="100%"
                padding="1rem"
                overflowY="off"
                bB="1px solid #AEB3C9"
            >
                <RecruitersCandidateCount />
            </Flex>
            <Flex
                direction="column"
                width="100%"
                height="100%"
                padding="1rem"
                overflowY="off"
                bB="1px solid #AEB3C9"
            >
                <LoginAndSignupsHistory />
            </Flex>
        </GroupWrapper>
    )
}

export default OverviewTables
